module.exports = __webpack_public_path__ + "static/media/chart-2.ece1c32d.svg";